/**
 * Class that contains static fields used by various UI related settings.
 */
export class UIModel {
  private static animationsBaseUrl: string = './assets/animations';

  /**
   * Gets URL for recovery link sent animation.
   */
  public static emailMotionAnimationUrl: string = `${UIModel.animationsBaseUrl}/email-motion-loading-animation.json`;

  /**
   * Gets URL for password successfully changed animation.
   */
  public static lockAnimationUrl: string = `${UIModel.animationsBaseUrl}/lock-animation.json`;

  /**
   * Gets URL for fatal error animation.
   */
  public static fatalErrorAnimationUrl: string = `${UIModel.animationsBaseUrl}/internal-error-animation.json`;

  /**
   * Gets URL for 404 error animation.
   */
  public static notFoundErrorAnimationUrl: string = `${UIModel.animationsBaseUrl}/error-404-animation.json`;

  /**
   * Gets URL for generic error animation.
   */
  public static genericErrorAnimation: string = `${UIModel.animationsBaseUrl}/error-animation.json`;

  /**
   * Gets URL for 404 alternate error animation.
   */
  public static notFoundAltErrorAnimationUrl: string = `${UIModel.animationsBaseUrl}/error-404-2-animation.json`;

  /**
   * Gets URL for mail sent animation.
   */
  public static emailSentAnimation: string = `${UIModel.animationsBaseUrl}/email-sent-animation.json`;

  /**
   * Gets URL for big data analysis animation.
   */
  public static dataAnalysisAnimation: string = `${UIModel.animationsBaseUrl}/big-data-analysis-animation.json`;

  /**
   * Gets URL for tricube spinner animation.
   */
  public static tricubeSpinnerAnimation: string = `${UIModel.animationsBaseUrl}/tricube-spinner-animation.json`;

  /**
   * Gets URL for loading animation.
   */
  public static loadingAnimationVariant: string = `${UIModel.animationsBaseUrl}/loading-animation-variant.json`;

  /**
   * Gets URL for success animation.
   */
  public static successAnimation: string = `${UIModel.animationsBaseUrl}/success-check-animation.json`;

  /**
   * Gets URL for package animation.
   */
  public static packageAnimation: string = `${UIModel.animationsBaseUrl}/package-animation.json`;

}
